import { Row, Col, Image } from 'react-bootstrap';
import React from 'react';
import { bio } from '../assets/text/bio';
import { atTheStudio } from '../assets/images';
import Meta from '../components/Meta';

const AboutScreen = () => {
  const formattedBio = bio.bio_v1.split('\n').map((paragraph, index) => (
    <React.Fragment key={index}>
      {paragraph}
      <br />
    </React.Fragment>
  ));
  return (
    <Row>
      <Meta
        title="About Limbism | Contemporary Digital Artist"
        description="Born in Ukraine, Limbism has carved out a distinct space in contemporary art by deconstructing and reassembling the human form. Creator of the Flower Series, Pop Culture Series and available for custom commissions."
        keywords="Limbism, about Limbism, contemporary digital artist, Ukrainian artist, flower series, pop culture art, human form, art deconstruction, custom art commission"
      />
      <Col className="col-md-4 mx-auto pt-4" md={6}>
        {formattedBio}
      </Col>
      <Col className="col-md-4 mx-auto pt-4" md={3}>
        <Image src={atTheStudio} alt="at the studio" fluid rounded></Image>
        <p className="text-center pt-4">At the studio with my apprentices</p>
      </Col>
    </Row>
  );
};

export default AboutScreen;
